import React, { useState } from 'react';
import { CalculatorAdvancedMode, CalculatorHTMMode } from '../classes/CalculatorMode';
import { CalculatorCurrencyValuesType } from '../constants/calculator_currency.constant';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import {
    CalculatorAdvancedModeContext,
    CalculatorCurrencyContext,
    CalculatorHtmModeContext,
    CalculatorRedirectHomeContext
} from './CalculatorContext';

export function CalculatorParamsOutlet(): JSX.Element {
    const calculatorModeState = useState<CalculatorHTMMode>(CalculatorHTMMode.Direct);
    const calculatorCurrencyState = useState<CalculatorCurrencyValuesType>('EUR');
    const calculatorRedirectHome = useState<boolean>(true);
    const calculatorAdvancedModeState = useState<CalculatorAdvancedMode>(CalculatorAdvancedMode.Simple);

    return (
        <CalculatorHtmModeContext.Provider value={calculatorModeState}>

            <CalculatorCurrencyContext.Provider value={calculatorCurrencyState}>

                <CalculatorRedirectHomeContext.Provider value={calculatorRedirectHome}>

                    <CalculatorAdvancedModeContext.Provider value={calculatorAdvancedModeState}>

                        <ScrollRestoration/>

                        <Outlet/>

                    </CalculatorAdvancedModeContext.Provider>

                </CalculatorRedirectHomeContext.Provider>

            </CalculatorCurrencyContext.Provider>

        </CalculatorHtmModeContext.Provider>
    );
}
